<template>
  <v-container fluid>
      <v-expand-transition>
        <!-- --------------inicio---------------------------- -->
          <v-card flat v-show="step == 1">        
            <v-row justify="center">
              <v-col cols="12">
                <v-row justify="center">
                  <span class="mx-3 mt-2" style="font-size: 34px; color: #616161">Catalogos</span>
                </v-row>
                <v-row justify="center" class="mt-n1 mx-1">
                  <span style="font-size: 16px; color: #757575"
                    >Crea nuevos catalogos de articulos
                  </span>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      dense
                      outlined
                      hide-details
                      v-model="filters.business"
                      :items="itemsBussines"
                      label="Unidad de negocio"
                      color="cyanText"
                      prepend-inner-icon="corporate_fare"
                      @change="changeBusiness({ business: filters.business, location: null })"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-card outlined class="ma-3">
                  <v-data-table
                    :headers="headers"
                    :items="catalogues"
                    :search="search"
                    sort-by="calories"
                    :items-per-page="7"
                    :page.sync="page"
                    hide-default-footer
                    @page-count="pageCount = $event"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Catalogos</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field
                          class="text-xs-center"
                          v-model="search"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details
                          outlined dense
                        >
                        </v-text-field>
                        <v-spacer></v-spacer>
                          <v-btn color="primary" dark class="mb-2" @click="newCatalogue()" outlined
                            v-if="$store.state.auth.globalFeatures.includes('INV-1133')">
                              <v-icon>add</v-icon>
                              Nuevo catalogo
                            </v-btn>                   
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on: menu, attrs }">
                          <v-btn small text color="primary" v-bind="attrs" v-on="menu"
                            :loading="loadingCatalogueId === item.id" :disabled="loadingCatalogueId === item.id">
                            Opciones
                            <v-icon left>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list dense>
                          <v-list-item @click="viewItem(item)"
                            v-if="$store.state.auth.globalFeatures.includes('INV-111') || $store.state.auth.globalFeatures.includes('INV-1132')">
                            <v-list-item-icon class="mr-3">
                              <v-icon color="success">mdi-eye-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Ver catalogo</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="editItem(item)"
                            v-if="$store.state.auth.globalFeatures.includes('INV-1132')">
                            <v-list-item-icon class="mr-3">
                              <v-icon color="blue">mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Editar catalogo</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="openLocations(item)"
                            v-if="$store.state.auth.globalFeatures.includes('INV-1131')">
                            <v-list-item-icon class="mr-3">
                              <v-icon color="primary">my_location</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Locations</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                    <template v-slot:no-data>
                      <v-row justify="center" class="pt-10">
                        <v-icon size="80px">token</v-icon>
                      </v-row>
                      <v-row justify="center" class="pb-6"> No hay datos </v-row>
                    </template>
                  </v-data-table>
                  <div class="d-flex justify-center py-3">
                    <v-pagination v-model="page" :length="pageCount" :total-visible="7" color="primary"></v-pagination>
                  </div>
                  </v-card>
              </v-col>
            </v-row>
          </v-card>
      </v-expand-transition>
      <v-expand-transition>
         <!-- --------------edicion de catalogo---------------------------- -->
          <v-card flat v-show="step == 2"> 
                <v-container fluid class="pt-0 mt-0">
                                                <v-row class="mt-0 mb-2" justify="center">
                                <span v-if="editedItem.business_unit_id">
                                  MONEDA BASE
                                  <b
                                    >{{
                                      itemsBussines.filter(
                                        (element) => element.value == editedItem.business_unit_id
                                      )[0].currency_description
                                    }}
                                  </b>
                                  <country-flag
                                    :country="
                                      getFlag(
                                        itemsBussines.filter(
                                          (element) =>
                                            element.value == editedItem.business_unit_id
                                        )[0].currency_id
                                      )
                                    "
                                    size="small"
                                  />
                                </span>
                              </v-row>
                            <v-row justify="center" class="mt-0 pt-0">
                              <v-col cols="12" sm="3" md="3">
                                <v-autocomplete
                                  dense
                                  outlined
                                  v-model="editedItem.business_unit_id"
                                  :items="itemsBussines"
                                  label="Unidad de negocio"
                                  color="cyanText"
                                  readonly
                                  prepend-inner-icon="corporate_fare"
                                ></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="3" md="3">
                                <v-text-field
                                  dense
                                  outlined
                                  v-model="editedItem.name"
                                  label="Nombre del catalogo"
                                  :readonly="isReadOnly"
                                  required
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-tabs v-model="detailTab" class="mb-2" v-show="editedItem.id != null">
                              <v-tab>
                                <v-icon left small>inventory_2</v-icon>
                                Articulos
                              </v-tab>
                              <v-tab>
                                <v-icon left small>my_location</v-icon>
                                Locations
                              </v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="detailTab">
                            <v-tab-item>
                            <v-flex>
                          <v-card outlined>
                            <v-card-text class="py-0 my-0">
                              <v-data-table
                                fixed-header
                                :headers="headersItemSelected"
                                :items="itemSelected"
                                :search="searchDetail"
                                :items-per-page="7"
                                :page.sync="detailPage"
                                hide-default-footer
                                @page-count="detailPageCount = $event"
                                dense
                              >
                                <template v-slot:top>
                                  <v-toolbar flat>
                                    <v-toolbar-title>Artículos</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <span>{{ currencyFormat(itemSelected.length).split('.')[0] }}</span>

                                    <v-spacer></v-spacer>
                                    <v-text-field
                                      class="text-xs-center mt-4"
                                      v-model="searchDetail"
                                      append-icon="search"
                                      label="Buscar"
                                      single-line
                                      outlined dense
                                    >
                                    </v-text-field>

                                    <v-spacer></v-spacer>
                                    <div class="d-flex align-center" style="gap: 8px;">
                                      <v-btn color="success" outlined @click="downloadXLSX">
                                        <v-icon left>mdi-microsoft-excel</v-icon>
                                        Exportar
                                      </v-btn>
                                      <ArticleFilters v-if="!isReadOnly" class="pt-4 mb-0"
                                        @getItemToEdit="addItem($event)"
                                        :showButonNewArticle="false"
                                        icon="arrow_right_alt"
                                        name="Agregar."
                                      />
                                    </div>
                                  </v-toolbar>
                                </template>

                                <template v-slot:[`item.index`]="{ index }">
                                  {{ (detailPage - 1) * 7 + index + 1 }}
                                </template>
                                <template v-slot:[`item.item_name`]="{ item }">
                                  <v-tooltip top v-if="item.is_internal">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-chip v-bind="attrs" v-on="on" x-small color="indigo" text-color="white" class="mr-2">
                                        <v-icon x-small>mdi-cog</v-icon>
                                      </v-chip>
                                    </template>
                                    <span>Articulo interno</span>
                                  </v-tooltip>
                                  <span :class="item.isNew ? 'red--text' : ''">{{
                                    item.item_name
                                  }}</span>
                                </template>
                                <template v-slot:[`item.item_type_name`]="{ item }">
                                <v-tooltip top>
                                 <template v-slot:activator="{ on, attrs }">
                                  <v-icon small color="success" v-bind="attrs"  v-on="on" v-if="item.is_inventoriable">mdi-package-variant-closed</v-icon> 
                                  <v-icon small color="error" v-bind="attrs"  v-on="on" v-else>mdi-package-variant-remove</v-icon> 
                                  <span :class="'pl-1 mb-2 '+(item.isNew ? 'red--text' : '')">{{
                                    item.item_type_name
                                  }}</span>
                                  </template>
                                  <span>Articulo {{ item.is_inventoriable?'':'no' }} inventariable</span>
                                  </v-tooltip>
                                </template>

                                <template v-slot:[`item.warehouse`]="{ item }">
                                  <v-autocomplete
                                    v-model="item.warehouse_id"
                                    v-if="[1, 3, 5].includes(item.item_type_id)"
                                    :class="'mt-2 mb-4 '+(item.isNew ? 'red--text' : '')"
                                    outlined
                                    dense :rules="[(v) => !!v || '']"
                                    style="font-size: 0.75rem; height: 27px;"
                                    :items="itemsWarehouse"
                                    label="Almacen"
                                   @change="set_is_new(item)"
                                    :readonly="isReadOnly"
                                    item-text="name"
                                    item-value="id"
                                    hide-details
                                    single-line
                                  ></v-autocomplete>
                                  <span v-else>----</span>
                                </template>
                                <template v-slot:[`item.account_category_id`]="{ item }">
                                  <v-autocomplete
                                    v-model="item.account_category_id"
                                    :items="accountCategorys.filter((element)=>element.business_unit_id == editedItem.business_unit_id || element.id == 0)"
                                     style="font-size: 0.75rem; height: 27px;"
                                    item-value="id"
                                    item-text="name"
                                     :class="'mt-2 mb-4 '+(item.isNew ? 'red--text' : '')"
                                    color="cyanText"
                                    label="Cuenta"
                                    @change="set_is_new(item)"
                                    :readonly="isReadOnly || item.is_internal"
                                    outlined :rules="[(v) => !!v || '']"
                                    required
                                    hide-details
                                    single-line
                                    dense
                                  >
                                  </v-autocomplete>
                                </template>
                                <template v-slot:[`item.tax_type_id`]="{ item }">
                                  <v-autocomplete
                                    v-model="item.tax_type_id"
                                    :items="taxes"
                                    item-value="id"
                                    item-text="name"
                                    :class="'mt-2 mb-4 '+(item.isNew ? 'red--text' : '')"
                                    color="cyanText"
                                    label="Tipo"
                                    outlined :rules="[(v) => !!v || '']"
                                    @change="set_is_new(item)"
                                    :readonly="isReadOnly || item.is_internal"
                                    required
                                    hide-details
                                    single-line
                                    dense  style="font-size: 0.75rem; height: 27px;"
                                  >
                                  </v-autocomplete>
                                </template>
                                <template v-slot:[`item.code`]="{ item }">
                                    <v-text-field
                                      style="font-size: 0.75rem; height: 27px;"
                                      dense hide-details 
                                      outlined  class="rounded-lg mt-2 mb-4"
                                      @input="set_is_new(item)"
                                      :readonly="isReadOnly"
                                      min="1"   prepend-inner-icon="mdi-barcode-scan"
                                      v-model="item.code"
                                    >
                                    </v-text-field>
                                </template>
                                <template v-slot:[`item.actions`]="{ item }">
                                <v-menu bottom origin="center center" transition="scale-transition">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      :color="item.isNew ? 'error' : 'primary'"
                                      dark   :disabled="item.is_internal"
                                      outlined
                                      v-bind="attrs"
                                      v-on="on"
                                    >Opciones
                                      <v-icon class="ml-2">settings</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list>
                                    <v-list-item @click="openDialogPrices(item)"
                                      v-if="!isReadOnly || $store.state.auth.globalFeatures.includes('INV-1134')">
                                      <v-list-item-icon>
                                        <v-icon color="success">attach_money</v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-title>{{ isReadOnly ? 'Ver precios' : 'Editar precios' }}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="!isReadOnly" :disabled="![1,3,5].includes(item.item_type_id)">
                                      <v-list-item-icon>
                                        <v-icon :color="item.is_inventoriable?'success':'error'" >mdi-package-variant-{{item.is_inventoriable?'closed':'remove'}}</v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-title>
                                           <v-checkbox  v-if="[1,3,5].includes(item.item_type_id)"
                                            v-model="item.is_inventoriable"
                                            color="cyanText" class="pt-0"
                                            :disabled="isReadOnly"
                                            @change="set_is_new(item)" @click.stop
                                            :label="`Es inventariable: ${item.is_inventoriable? 'Si': 'No'}`"
                                          ></v-checkbox>
                                          <span v-else>
                                            Es invnetariable: No aplica
                                          </span>
                                      </v-list-item-title>
                                    </v-list-item>                              
                                    <v-list-item @click="deleteItemSelected(item)" v-if="!isReadOnly && $store.state.auth.globalFeatures.includes('INV-1130')">
                                      <v-list-item-icon>
                                        <v-icon color="error">delete</v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-title>Remover item del catalogo</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                                  <!-- <v-icon small class="mr-2" @click="editItem(item)">
                                  mdi-pencil
                                </v-icon>
                                <v-icon small @click="deleteItem(item)">
                                  mdi-delete
                                </v-icon> -->
                                </template>
                                <template v-slot:no-data>
                                  <v-row justify="center" class="pt-10">
                                    <v-icon size="80px">token</v-icon>
                                  </v-row>
                                  <v-row justify="center" class="pb-6"> No hay datos </v-row>
                                </template>
                              </v-data-table>
                              <div class="d-flex justify-center py-3">
                                <v-pagination v-model="detailPage" :length="detailPageCount" :total-visible="7" color="primary"></v-pagination>
                              </div>
                            </v-card-text>
                                  <v-card-actions class="pt-0 mt-0">
                                    <span class="red--text" v-show="pending_save>0 && !isReadOnly">Cambios sin guardar: {{ pending_save }}</span>
                                    <v-spacer></v-spacer>
                                    <v-btn v-if="editedItem.id == null" @click="detailTab = 1" text class="mx-2">
                                      <v-icon left>mdi-chevron-left</v-icon> Locations
                                    </v-btn>
                                    <v-btn @click="step = 1" text class="mx-2">{{ isReadOnly ? 'Volver' : 'Cancelar' }}</v-btn>
                                     <v-badge color="red" overlap dot :value="pending_save>0" v-if="!isReadOnly">
                                       <v-btn @click="save" color="primary" outlined>Guardar</v-btn>
                                     </v-badge>
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                              </v-card>
                            </v-flex>
                            </v-tab-item>
                            <v-tab-item>
                              <v-flex>
                                <v-card outlined>
                                  <v-card-text>
                                    <v-alert
                                      v-if="editedItem.id == null"
                                      type="info"
                                      text
                                      dense
                                      class="mb-2"
                                    >
                                      Marca las locations que usaran este catalogo.
                                    </v-alert>
                                    <v-data-table
                                      :headers="headersLocations"
                                      :items="businessLocations"
                                      :loading="loadingLocations"
                                      :search="searchLocation"
                                      dense
                                      :items-per-page="20"
                                      loading-text="Cargando locations..."
                                    >
                                      <template v-slot:top>
                                        <v-toolbar flat>
                                          <v-toolbar-title>Locations de la unidad de negocio</v-toolbar-title>
                                          <v-divider class="mx-4" inset vertical></v-divider>
                                          <v-spacer></v-spacer>
                                          <v-text-field
                                            class="text-xs-center mt-4"
                                            v-model="searchLocation"
                                            append-icon="search"
                                            label="Buscar"
                                            single-line
                                            outlined dense
                                          ></v-text-field>
                                        </v-toolbar>
                                      </template>
                                      <template v-slot:[`item.catalogue_name`]="{ item }">
                                        <v-chip
                                          v-if="item.catalogue_id"
                                          small
                                          :color="item.catalogue_id == editedItem.id ? 'success' : 'grey lighten-2'"
                                          :text-color="item.catalogue_id == editedItem.id ? 'white' : ''"
                                        >
                                          {{ item.catalogue_name }}
                                        </v-chip>
                                        <span v-else class="text-caption grey--text">Sin catalogo</span>
                                      </template>
                                      <template v-slot:[`item.assigned`]="{ item }">
                                        <v-switch
                                          :key="'sw-' + item.id + '-' + switchKey"
                                          :input-value="isLocationSelected(item)"
                                          :loading="item.loading"
                                          :disabled="item.loading || isReadOnly"
                                          color="success"
                                          hide-details
                                          class="mt-0 pt-0"
                                          @change="editedItem.id == null ? toggleLocationUi(item, $event) : requestToggleLocation(item, $event)"
                                        ></v-switch>
                                      </template>
                                      <template v-slot:no-data>
                                        <v-row justify="center" class="pt-10">
                                          <v-icon size="80px">token</v-icon>
                                        </v-row>
                                        <v-row justify="center" class="pb-6"> No hay locations </v-row>
                                      </template>
                                    </v-data-table>
                                  </v-card-text>
                                  <v-card-actions class="pt-0 mt-0">
                                    <v-spacer></v-spacer>
                                    <v-btn @click="step = 1" text class="mx-2">{{ editedItem.id == null ? 'Cancelar' : 'Volver' }}</v-btn>
                                    <v-btn v-if="editedItem.id == null" @click="goToArticles" :loading="loadingWarehouses" color="primary" outlined class="mx-2">
                                      Siguiente: Articulos <v-icon right>mdi-chevron-right</v-icon>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-flex>
                            </v-tab-item>
                            </v-tabs-items>
                          </v-container>
          </v-card>
      </v-expand-transition>
    <v-dialog
      transition="slide-x-transition"
      hide-overlay
      v-model="dialogPrices"
      width="800px"
      height="10vh"
    >
      <v-card v-if="dialogPrices == true" style="background-color: #f4f5fa" height="auto">
        <v-toolbar color="#F4F5FB" elevation="0">
          <span class="font-weight-bold mx-2">
            Precios: {{ itemSelected[editedIndexPrice].item_name }}</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialogPrices">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title></v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="itemSelected[editedIndexPrice].cost_price_update_type_id"
                  :items="categoriesCostPrice"
                  class="ml-4"
                  item-value="id"
                  item-text="name"
                  color="cyanText"
                  label="Tipo de Costo"
                  :readonly="isReadOnly"
                  outlined
                  required
                  dense
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-simple-table v-if="dialogPrices == true" fixed-header height="auto">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Precio compra</th>
                      <th class="text-left">Precio venta</th>
                    </tr>
                  </thead>
                  <tbody v-if="!loadPrices">
                    <tr
                      v-for="(currency, i) in itemSelected[editedIndexPrice]
                        .item_currencies"
                      :key="i"
                    >
                      <td>{{ currency.currency_code }}</td>
                      <td>
                        <v-text-field
                          :disabled="
                            (itemsBussines.filter(
                              (element) => element.value == editedItem.business_unit_id
                            )[0].currency_id ==
                              currency.currency_id) ==
                            false
                          "
                          style="font-size: 0.8vw"
                          @input="setCostPriceExchange(currency)"
                          type="number"
                          dense
                          outlined
                          :readonly="isReadOnly"
                          min="0"
                          v-model="currency.cost_price"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          style="font-size: 0.8vw"
                          type="number"
                          :disabled="
                            (itemsBussines.filter(
                              (element) => element.value == editedItem.business_unit_id
                            )[0].currency_id ==
                              currency.currency_id) ==
                            false
                          "
                          :suffix="
                            getTaxesPrice(
                              currency.sale_price,
                              itemSelected[editedIndexPrice].tax_type_id
                            )
                          "
                          @input="setSalePriceExchange(currency)"
                          dense
                          outlined
                          :readonly="isReadOnly"
                          min="0"
                          v-model="currency.sale_price"
                        ></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                style="font-size: 0.8vw"
                type="number"
                label="Reorden minimo"
                dense
                outlined
                :readonly="isReadOnly"
                min="0"
                v-model="itemSelected[editedIndexPrice].min"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                style="font-size: 0.8vw"
                type="number"
                dense
                label="Reorden maximo"
                outlined
                :readonly="isReadOnly"
                min="0"
                v-model="itemSelected[editedIndexPrice].max"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-card-text>
          <v-row justify="center">
            <v-btn @click="closeDialogPrices" text class="mx-2">Cancelar</v-btn>

            <v-btn
              v-if="
                !isReadOnly && (
                $store.state.auth.globalFeatures.includes('INV-1121') ||
                itemSelected[editedIndexPrice].isNew)
              "
              @click="saveDialogPrices(itemSelected[editedIndexPrice])"
              color="primary"
              outlined
              >Guardar</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
     <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                          <v-card-title class="text-h5">Quieres eliminar este item?</v-card-title>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                              >OK</v-btn
                            >
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
    <v-dialog v-model="dialogAssign" max-width="460" persistent>
      <v-card v-if="pendingLocation">
        <v-card-title class="text-h6">
          <v-icon :color="pendingAssign ? 'success' : 'error'" class="mr-2">
            {{ pendingAssign ? 'mdi-link-variant' : 'mdi-link-variant-off' }}
          </v-icon>
          {{ pendingAssign ? 'Asignar catalogo' : 'Quitar catalogo' }}
        </v-card-title>
        <v-card-text>
          <span v-if="pendingAssign">
            ¿Asignar el catalogo <b>{{ editedItem.name }}</b> a la location
            <b>{{ pendingLocation.description_long }}</b>?
            <template v-if="pendingLocation.catalogue_id && pendingLocation.catalogue_id != editedItem.id">
              <br />Actualmente usa <b>{{ pendingLocation.catalogue_name }}</b> y sera reemplazado.
            </template>
          </span>
          <span v-else>
            ¿Quitar el catalogo <b>{{ editedItem.name }}</b> de la location
            <b>{{ pendingLocation.description_long }}</b>?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelToggleLocation">Cancelar</v-btn>
          <v-btn :color="pendingAssign ? 'success' : 'error'" text @click="confirmToggleLocation">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import ExcelJS from "exceljs";
import ArticleFilters from "@/components/Inventory/ArticleSelectionList.vue";
export default {
  components: { ArticleFilters },
  props: {
    amount: {
      type: Number,
    },
  },
  data: () => ({
    step: 1,
    page: 1,
    pageCount: 0,
    detailPage: 1,
    detailPageCount: 0,
    dialogDelete: false,
    dialogPrices: false,
    loadPrices: false,
    headers: [
      { text: "ID", value: "id", align: "start" },
      {
        text: "Descripcion",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Unidad de negocio", value: "bussines_unit_description" },
      { text: "Articulos", value: "items_count", align: "center" },
      { text: "Locations", value: "locations_count", align: "center" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headersItemSelected: [
      {
        text: "#",
        align: "center",
        value: "index",
        sortable: false,
        width: "3%",
      },
      {
        text: "ID",
        align: "start",
        value: "item_id",
        width: "5%",
      },
      { text: "Descripción", value: "item_name", width: "20%" },
      { text: "Tipo", value: "item_type_name", align: "center" },
      { text: "Medida", value: "unit_name",  align: "center" },
      //  { text: "R Min", value: "min", width: "5%", align: "center" },
      //  { text: "R Max", value: "max", width: "5%", align: "center" },
      {
        text: "Almacén a descontar",
        value: "warehouse",
        align: "center",
        width: "10%",
      },
      { text: "Contabilidad", value: "account_category_id", width: "10%",align: "center" },
      { text: "Itbis", value: "tax_type_id", width: "7%",align: "center" },
      { text: "Codigo barra", value: "code", width: "10%",align: "center" },

      //{ text: "Precio venta", value: "sale_price", width: "10%" },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        width: "5%",
      },
    ],
    headersLocations: [
      { text: "ID", value: "id", width: "10%" },
      { text: "Location", value: "description_long" },
      { text: "Catalogo actual", value: "catalogue_name", align: "center" },
      { text: "Asignado", value: "assigned", sortable: false, align: "center", width: "120px" },
    ],
    search: "",
    searchLocation: "",
    opts: [10, 40, 60],
    detailTab: 0,
    isReadOnly: false,
    businessLocations: [],
    selectedLocationIds: [],
    loadingLocations: false,
    loadingWarehouses: false,
    loadingCatalogueId: null,
    dialogAssign: false,
    pendingLocation: null,
    pendingAssign: false,
    switchKey: 0,
    itemSelected: [],
    catalogues: [],
    taxes: [],
    searchDetail: "",
    editedIndex: -1,
    editedIndexPrice: -1,
    itemsBussines: [],
    itemsLocations: [],
    itemsLocations2: [],
    itemsWarehouse: [],
    catalogueLocations: [],
    categories: [],
    currencies: [],
    accountCategorys: [],
    filters: {
      business: null,
      location: null,
    },
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    categoriesCostPrice: [],
  }),

  computed: {
    pending_save(){
      return this.itemSelected.filter(element=>element.isNew).length;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New catalogo" : "Editar catalogo";
    },
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    if (this.$store.state.auth.globalFeatures.includes("INV-1130")) {
      this.headersItemSelected[this.headersItemSelected.length - 1].align = "center";
    }
    this.initialize();
  },

  methods: {
    async initialize() {
      this.itemsBussines = Object.assign([], this.$store.state.auth.bussines_units);
      const result = await Promise.all([
        this.api_Get("accounting/currencies"),
        this.api_Get("accounting/taxes"),
        this.api_Get("accounting/categories"),//accountCategorys
        this.api_Get("inventory/categoriesCostPrice"),
      ]);

      this.currencies = await result[0].json();

      this.taxes = await result[1].json();
      this.accountCategorys = await result[2].json();
      this.categoriesCostPrice = await result[3].json();
      this.itemsLocations = this.$store.state.auth.locations;

      // Toma la unidad de negocio almacenada en los filtros del store;
      // si esta vacia, usa la primera de la lista.
      const storedBusiness = this.$store.state.app.filters.business;
      this.filters.business =
        storedBusiness != null
          ? storedBusiness
          : this.itemsBussines.length
          ? this.itemsBussines[0].value
          : null;

      if (this.filters.business != null) {
        this.changeBusiness({ business: this.filters.business, location: null });
      }
    },
    async setCostPriceExchange(filters) {
      let cost = parseFloat(filters.cost_price);
      if (Number.isNaN(cost)) {
        this.loadPrices = false;
        return;
      }
      for (var item of this.itemSelected[this.editedIndexPrice].item_currencies) {
        let data = {
          business_unit_id: this.editedItem.business_unit_id,
          effective_date: moment().format("YYYY-MM-DD"),
          currency_invoice_id: filters.currency_id,
          currency_to: item.currency_id,
        };

        let response = await this.api_Post("accounting/currenciesByInvoice", data);
        if (response.status == 200) {
          let datas = await response.json();
          let rate = datas.length > 0 ? parseFloat(datas[0].value) : 0;
          if (filters.currency_id != item.currency_id) {
            let amount = cost * parseFloat(rate);
            item.cost_price = amount;
          }
        }
      }
    },
    async setSalePriceExchange(filters) {
      let sale = parseFloat(filters.sale_price);
      if (Number.isNaN(sale)) {
        this.loadPrices = false;
        return;
      }

      for (var item of this.itemSelected[this.editedIndexPrice].item_currencies) {
        let data = {
          business_unit_id: this.editedItem.business_unit_id,
          effective_date: moment().format("YYYY-MM-DD"),
          currency_invoice_id: filters.currency_id,
          currency_to: item.currency_id,
        };
        let response = await this.api_Post("accounting/currenciesByInvoice", data);
        if (response.status == 200) {
          let datas = await response.json();
          let rate = datas.length > 0 ? parseFloat(datas[0].value) : 0;
          if (filters.currency_id != item.currency_id) {
            let amount = sale * parseFloat(rate);

            item.sale_price = amount;
          }
        }
      }
    },
    async saveDialogPrices(data) {
      if (
        data.cost_price_update_type_id === undefined ||
        data.cost_price_update_type_id === null
      ) {
        this.$toast.info("Debes agregar un tipo de costo");
        return;
      }

      // Validación de cost_price y sale_price
      // const invalidCurrenciesAmount = data.item_currencies.filter((currency) => {
      //   return parseFloat( currency.cost_price) > parseFloat(currency.sale_price)
      // });

      // if (invalidCurrenciesAmount.length > 0) {
      //   this.$toast.error(
      //     "EL precio de venta deber ser mayor al costo"
      //   );
      //   return;
      // }

      const invalidCurrencies = data.item_currencies.filter((currency) => {
        return currency.cost_price < 0 || currency.sale_price < 0;
      });

      if (invalidCurrencies.length > 0) {
        this.$toast.error(
          "Los precios de costo o venta no pueden ser menores o iguales a cero."
        );
        return;
      }
      if (data.isNew === true) {
        this.closeDialogPrices();
        return;
      }
      let details = [];
      let warehouse = null;

      this.itemSelected[this.editedIndexPrice].isNew = true;
      for (let item of this.itemSelected) {
        if (!item.isNew) continue;

        if (item.tax_type_id == undefined) {
          this.$toast.warning("Debes agregar un impuesto al item " + item.item_name + " !");
          return;
        }
        if (item.account_category_id == undefined) {
          this.$toast.warning(
            "Debes agregar una cuenta contable al item:  " + item.item_name + " !"
          );
          return;
        }

        if (item.item_type_id == 1 || item.item_type_id == 5) {
          if (item.warehouse_id == undefined) {
            this.$toast.info(
              "Debes agregar un almacén a descontar para " + item.item_name + " !"
            );
            return;
          } else {
            warehouse = item.warehouse_id;
          }
        } else {
          warehouse = null;
        }

        let all_prices = [];
        for (var pr of item.item_currencies) {
          if (parseFloat(pr.sale_price) == 0) {
            this.$toast.info(`el item ${item.item_name} debe tener un precio de venta`);
            return;
          }
          if (parseFloat(pr.cost_price) == 0) {
            this.$toast.info(`el item ${item.item_name} debe tener un precio de costo`);
            return;
          }
          if (parseFloat(pr.sale_price) < parseFloat(pr.cost_price)) {
            this.$toast.info(`la venta de ${item.item_name} debe ser mayor al costo`);
            return;
          }
          all_prices.push({
            item_id: item.item_id,
            currency_id: pr.currency_id,
            sale_price: pr.sale_price,
            cost_price: pr.cost_price,
          });
        }

        details.push({
          item_id: item.item_id,

          item_currencies: all_prices,
          code: item.code,
          warehouse_id: warehouse,
          min: item.min,
          max: item.max,
          category_id: 62,
          account_category_id: item.account_category_id,
          tax_type_id: item.tax_type_id,
          cost_price_update_type_id: item.cost_price_update_type_id,
          is_inventoriable: item.item_type_id === 1 ? item.is_inventoriable : false,
          user_id: this.$store.state.auth.user.user.user_id,
        });
      }

      let item = {
        catalogue_id: this.editedItem.id,
        details: details,
        bussines_unit: this.editedItem.business_unit_id,
        name: this.editedItem.name.toUpperCase().trim(),
      };

      if (this.editedIndex > -1) {
        const responseRequest = await this.api_Put("inventory/catalogues/details", item);

        if (responseRequest.status == 200) {
          let data = await responseRequest.json();
          this.initialize();
          this.$toast.success("agregado con exito!");
          this.itemSelected[this.editedIndexPrice].isNew = false;
          this.dialogPrices = false;
          this.step = 1;
        } else {
          this.$toast.error("error al registrar el catalogo!");
        }
      } else {
        if (this.editedItem.business_unit_id == "") {
          this.$toast.error("Debes selecionar una unidad de negocio!");
        }

        if (this.editedItem.name == "") {
          this.$toast.error("Debes selecionar un nombre!");
        }
        const responseRequest = await this.api_Post("inventory/catalogues/details", item);

        if (responseRequest.status == 200) {
          this.initialize();
          this.$toast.success("agregado con exito!");
          this.step = 1;
          this.close();
        } else {
          this.$toast.error("error al registrar el catalogo!");
        }
      }
    },
    closeDialogPrices() {
      this.dialogPrices = false;
    },
    openDialogPrices(item) {
      if (item.tax_type_id == undefined || item.tax_type_id == null) {
        this.$toast.info("Debes agregar un impuesto");
        return;
      }

      this.editedIndexPrice = this.itemSelected.indexOf(item);
      this.dialogPrices = true;
    },
    getTaxesPrice(price, tax) {
      let itbis = this.taxes.filter((element) => element.id == tax)[0].value;

      let tot = parseFloat(price) * parseFloat(itbis) + parseFloat(price);
      if (itbis == 0) {
        return this.currencyFormat(parseFloat(price));
      }
      return "+ITBIS " + this.currencyFormat(tot);
    },
    async changeBusiness(filter) {
      const responseRequest = await this.api_Post("inventory/catalogues_bussines", {
        business_unit_id: filter.business,
        location_id:
          filter.location != null && filter.location != 0 ? filter.location : null,
      });

      if (responseRequest.status == 200) {
        this.catalogues = await responseRequest.json();
      }
    },
    async showWarehouse() {
      // Los almacenes salen de las locations del catalogo.
      // - Al crear (sin id): de las locations marcadas en UI (selectedLocationIds).
      // - Al editar: de las locations ya asignadas al catalogo.
      let data = [];
      if (this.editedItem.id == null) {
        if (this.selectedLocationIds.length === 0) {
          this.itemsWarehouse = [];
          return;
        }
        const resp = await this.api_Post("inventory/warehouses_for_locations", {
          location_ids: this.selectedLocationIds,
        });
        data = await resp.json();
      } else {
        const warehouses = await this.api_Get(
          "inventory/warehousesForCatalogue/" + this.editedItem.id
        );
        data = await warehouses.json();
      }
      this.itemsWarehouse = data.map((w) => ({
        ...w,
        name: `${w.name} (${w.location_description_long})`,
      }));
    },
    isLocationSelected(location) {
      // En creacion: seleccion UI. En edicion: catalogo ya asignado.
      if (this.editedItem.id == null) {
        return this.selectedLocationIds.includes(location.id);
      }
      return location.catalogue_id == this.editedItem.id;
    },
    async goToArticles() {
      // Antes de pasar a articulos valida que las locations marcadas tengan almacenes.
      if (this.selectedLocationIds.length === 0) {
        this.$toast.warning("Selecciona al menos una location!");
        return;
      }
      this.loadingWarehouses = true;
      await this.showWarehouse();
      this.loadingWarehouses = false;
      if (this.itemsWarehouse.length === 0) {
        this.$toast.error(
          "Ninguna de las locations seleccionadas tiene almacenes creados. Crea almacenes antes de continuar."
        );
        return;
      }
      this.detailTab = 0;
    },
    toggleLocationUi(location, value) {
      // Solo UI: marca/desmarca la location (se guarda junto al catalogo al final).
      const idx = this.selectedLocationIds.indexOf(location.id);
      if (value) {
        if (idx === -1) this.selectedLocationIds.push(location.id);
      } else {
        if (idx > -1) this.selectedLocationIds.splice(idx, 1);
      }
      // Recalcula los almacenes disponibles segun las locations marcadas.
      this.showWarehouse();
    },
    viewItem(item) {
      // Ver catalogo: solo lectura.
      this.openCatalogue(item, true, 0);
    },
    editItem(item) {
      // Editar catalogo: editable, tab de articulos.
      this.openCatalogue(item, false, 0);
    },
    openLocations(item) {
      // Asignar/quitar locations: abre el detalle en el tab de Locations.
      this.openCatalogue(item, false, 1);
    },
    newCatalogue() {
      // Nuevo catalogo: usa la unidad de negocio del filtro (informativa, no se pide).
      if (this.filters.business == null) {
        this.$toast.info("Selecciona una unidad de negocio en el filtro primero!");
        return;
      }
      this.isReadOnly = false;
      const actionsHeader = this.headersItemSelected.find((h) => h.value === "actions");
      if (actionsHeader) actionsHeader.align = "center";
      this.editedIndex = -1;
      this.itemSelected = [];
      this.itemsWarehouse = [];
      this.selectedLocationIds = [];
      this.detailTab = 1; // primero marcar locations
      this.editedItem = {
        id: null,
        name: "",
        business_unit_id: this.filters.business,
      };
      this.loadBusinessLocations();
      this.loadInternalItems();
      this.step = 2;
    },
    async loadInternalItems() {
      // Al crear un catalogo se precargan los items internos del sistema (is_internal=true).
      try {
        const resp = await this.api_Post("inventory/articles", {
          filters: "WHERE IS_INTERNAL = TRUE",
          page: 1,
          limit: 1000,
          search: "",
          orderBy: "item_name",
          orderDirection: "ASC",
        });
        if (resp.status != 200) return;
        const result = await resp.json();
        const items = result.data || [];
        const newItems = [];
        for (const it of items) {
          if (this.itemSelected.find((e) => e.item_id == it.item_id)) continue;
          const is_inventoriable = [1, 3, 5].includes(it.item_type_id);
          let item_currencies = [];
          for (var currency of this.currencies) {
            item_currencies.push({
              currency_id: currency.id,
              currency_code: currency.code,
              // Precios por defecto para los items internos (compra 1, venta 2).
              sale_price: 2,
              cost_price: 1,
            });
          }
          newItems.push({
            ...it,
            max: 0,
            min: 0,
            is_inventoriable,
            warehouse_id: null,
            is_internal: true,
            // Itbis exento por defecto (primero de la lista) para los items internos.
            tax_type_id: this.taxes.length ? this.taxes[0].id : null,
            // Cuenta contable general (id 0) para los items internos.
            account_category_id: 0,
            // Tipo de costo: primero de la lista.
            cost_price_update_type_id: this.categoriesCostPrice.length
              ? this.categoriesCostPrice[0].id
              : null,
            isNew: true,
            item_currencies,
          });
        }
        // Igual que al agregar manualmente: se colocan al inicio de la tabla.
        if (newItems.length) {
          this.itemSelected.unshift(...newItems);
        }
      } catch (error) {
        this.$toast.error("Error al cargar los items internos");
      }
    },
    async openCatalogue(catalogue, readonly, tab) {
      // Muestra el loading en el boton "Opciones" de la fila mientras se consulta el detalle.
      this.loadingCatalogueId = catalogue.id;
      try {
        this.isReadOnly = readonly;
        // En solo lectura la columna de acciones solo sirve para "Ver precios";
        // se oculta si el usuario no tiene el permiso de ver precios (INV-1134).
        const canViewPrices = this.$store.state.auth.globalFeatures.includes("INV-1134");
        const actionsHeader = this.headersItemSelected.find((h) => h.value === "actions");
        if (actionsHeader) {
          actionsHeader.align = readonly && !canViewPrices ? " d-none" : "center";
        }
        this.detailTab = tab;
        this.editedIndex = this.catalogues.indexOf(catalogue);
        this.editedItem = Object.assign({}, catalogue);

        await this.loadDetails();

        // Al editar, agrega los items internos que falten (p. ej. internos creados
        // despues del catalogo) para que sea facil incorporarlos a catalogos existentes.
        if (!readonly) {
          await this.loadInternalItems();
        }

        this.showWarehouse();
        this.loadBusinessLocations();

        this.step = 2;
      } finally {
        this.loadingCatalogueId = null;
      }
    },
    async loadDetails() {
      let resultCatalogues = await this.api_Get(
        "inventory/catalogues/details/" + this.editedItem.id
      );
      let data = await resultCatalogues.json();

      for (var item of data) {
        if (item.item_currencies == null) {
          item.item_currencies = [];
          for (var currency of this.currencies) {
            item.item_currencies.push({
              currency_id: currency.id,
              currency_code: currency.code,
              sale_price: 0,
              cost_price: 0,
            });
          }
        }
      }
      this.itemSelected = data;
    },
    async loadBusinessLocations() {
      // Todas las locations de la unidad de negocio del catalogo, con el catalogo que tienen asignado.
      if (this.editedItem.business_unit_id == null) {
        this.businessLocations = [];
        return;
      }
      this.loadingLocations = true;
      try {
        const resp = await this.api_Get(
          "inventory/catalogues/business_locations/" + this.editedItem.business_unit_id
        );
        let data = await resp.json();
        this.businessLocations = data.map((l) => ({ ...l, loading: false }));
      } catch (error) {
        this.$toast.error("Error al cargar las locations");
      }
      this.loadingLocations = false;
    },
    requestToggleLocation(location, value) {
      // En solo lectura (ver catalogo) no se permite modificar las locations.
      if (this.isReadOnly) {
        this.switchKey++; // revierte el switch a su estado real
        return;
      }
      // Valida permiso y pide confirmacion antes de asignar/reasignar el catalogo a la location.
      if (!this.$store.state.auth.globalFeatures.includes("INV-1131")) {
        this.$toast.warning(
          "No tiene autorizacion para asignar o reasignar catalogos a locations."
        );
        this.switchKey++; // revierte el switch a su estado real
        return;
      }
      this.pendingLocation = location;
      this.pendingAssign = value;
      this.dialogAssign = true;
    },
    async confirmToggleLocation() {
      this.dialogAssign = false;
      const location = this.pendingLocation;
      const assign = this.pendingAssign;
      this.pendingLocation = null;
      await this.toggleLocation(location, assign);
      this.switchKey++; // re-sincroniza el switch con el estado real
    },
    cancelToggleLocation() {
      this.dialogAssign = false;
      this.pendingLocation = null;
      this.switchKey++; // revierte el switch
    },
    async toggleLocation(location, assign) {
      if (this.editedItem.id == null) {
        this.$toast.info("Guarda el catalogo primero para asignarle locations!");
        return;
      }
      this.$set(location, "loading", true);
      try {
        const resp = await this.api_Put("inventory/catalogues/assign_location", {
          catalogue_id: this.editedItem.id,
          location_id: location.id,
          assign: assign,
        });
        if (resp.status == 200) {
          if (assign) {
            location.catalogue_id = this.editedItem.id;
            location.catalogue_name = this.editedItem.name;
          } else {
            location.catalogue_id = null;
            location.catalogue_name = null;
          }
          // Los almacenes dependen de las locations del catalogo: recargar opciones.
          this.showWarehouse();
          // Al quitar una location, el backend reasigna el almacen por defecto de
          // los items afectados: recargamos el detalle para reflejarlo.
          if (!assign) {
            await this.loadDetails();
          }
          this.$toast.success(assign ? "Location asignada!" : "Location removida!");
        } else {
          this.$toast.error("Error al actualizar la location");
        }
      } catch (error) {
        this.$toast.error("Error al actualizar la location");
      }
      this.$set(location, "loading", false);
    },

    addItem(item) {
      if (this.editedItem.business_unit_id == undefined) {
        this.$toast.info("Debes seleccionar una unidad de negocio!");
        return;
      }

      if (this.itemSelected.find((element) => element.item_id == item.item_id) != undefined) {
        this.$toast.info("El articulo no esta, o ya encuentra agregado!");
        return
      } 

      // Establecer is_inventoriable basado en item_type_id
      const is_inventoriable = [1, 3, 5].includes(item.item_type_id) ? true : false;

      let item_currencies = [];
      for (var currency of this.currencies) {
        item_currencies.push({
          currency_id: currency.id,
          currency_code: currency.code,
          sale_price: 0,
          cost_price: 0,
        });
      }
    
      this.itemSelected.unshift({...item,max:0,min:0,is_inventoriable:is_inventoriable,warehouse_id:null,isNew:true,item_currencies:item_currencies});
    },
    async deleteItemSelected(item) {
      if (!this.$store.state.auth.globalFeatures.includes("INV-1130")) {
        return;
      }
      if (item.isNew == true) {
        this.itemSelected.splice(this.itemSelected.indexOf(item), 1);
        return;
      }
      let data = { catalogue_id: item.catalogue_id, item_id: item.item_id };

      const responseRequest = await this.api_Post(
        "inventory/catalogues/deleteItem",
        data
      );

      if (responseRequest.status == 200) {
        let editedIndex = this.itemSelected.indexOf(item);

        this.itemSelected.splice(editedIndex, 1);
        this.$toast.success("articulo eliminado con exito!");
      } else {
        this.$toast.error("error al eliminar el catalogo!");
      }
    },
    deleteItem(item) {
      this.editedIndex = this.catalogues.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.catalogues.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    updateCombo(itemsOrigen, itemsDestino, condicion, combo) {
      itemsDestino.splice(0, itemsDestino.length);

      for (let item of itemsOrigen) {
        if (item.bus_id === condicion) {
          itemsDestino.push({
            value: item.value,
            text: item.text,
            routes: item.routes,
          });
        }
      }

      return itemsDestino;
    },
    close() {
      this.step = 1;
      this.itemSelected = [];
      this.editedItem = [];
      this.catalogueLocations = [];
      this.itemsWarehouse = [];
      this.businessLocations = [];
      this.selectedLocationIds = [];
      this.isReadOnly = false;
      this.detailTab = 0;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      let details = [];
      let warehouse = null;

      for (let item of this.itemSelected) {
        if (!item.isNew) continue;

        if (item.tax_type_id == undefined) {
          this.$toast.warning("Debes agregar un impuesto al item: " + item.item_name + " !");
          return;
        }
        if (item.account_category_id == undefined) {
          this.$toast.warning(
            "Debes agregar una cuenta de contabilidad al item: " + item.item_name + " !"
          );
          return;
        }

        if (item.item_type_id == 1 || item.item_type_id == 5) {
          if (item.warehouse_id == undefined) {
            this.$toast.info(
              "Debes agregar un almacén a descontar para el item: " + item.item_name + " !"
            );
            return;
          } else {
            warehouse = item.warehouse_id;
          }
        } else {
          warehouse = null;
        }

        let all_prices = [];
        for (var pr of item.item_currencies) {
          if (parseFloat(pr.sale_price) == 0) {
            this.$toast.info(`el item ${item.item_name} debe tener un precio de venta`);
            return;
          }
          if (parseFloat(pr.cost_price) == 0) {
            this.$toast.info(`el item ${item.item_name} debe tener un precio de costo`);
            return;
          }
          if (parseFloat(pr.sale_price) < parseFloat(pr.cost_price)) {
            this.$toast.info(`la venta de ${item.item_name} debe ser mayor al costo`);
            return;
          }
          all_prices.push({
            item_id: item.item_id,
            currency_id: pr.currency_id,
            sale_price: pr.sale_price,
            cost_price: pr.cost_price,
          });
        }

        details.push({
          item_id: item.item_id,

          item_currencies: all_prices,
          code: item.code,
          warehouse_id: warehouse,
          min: item.min,
          max: item.max,
          category_id: 62,
          account_category_id: item.account_category_id,
          tax_type_id: item.tax_type_id,
          cost_price_update_type_id: item.cost_price_update_type_id,
          user_id: this.$store.state.auth.user.user.user_id,
          is_inventoriable: item.is_inventoriable == null ? false : item.is_inventoriable,
        });
      }

      let item = {
        catalogue_id: this.editedItem.id,
        details: details,
        bussines_unit: this.editedItem.business_unit_id,
        name: this.editedItem.name.toUpperCase().trim(),
        // Locations marcadas en UI (solo se usan al crear; el backend las asigna junto al catalogo).
        location_ids: this.selectedLocationIds,
      };
      if (this.editedIndex > -1) {
        const responseRequest = await this.api_Put("inventory/catalogues/details", item);

        if (responseRequest.status == 200) {
          // Refresca solo la unidad de negocio ya seteada en el filtro (no reinicia desde el store).
          this.changeBusiness({ business: this.filters.business, location: null });
          this.$toast.success("agregado con exito!");
          this.step = 1;
        } else {
          this.$toast.error("error al registrar el catalogo!");
        }
      } else {
        if (this.editedItem.business_unit_id == null || this.editedItem.business_unit_id === "") {
          this.$toast.error("Debes selecionar una unidad de negocio!");
          return;
        }

        if (this.editedItem.name == null || this.editedItem.name.trim() === "") {
          this.$toast.error("Debes indicar un nombre!");
          return;
        }
        const responseRequest = await this.api_Post("inventory/catalogues/details", item);

        if (responseRequest.status != 200) {
          this.$toast.error("error al registrar el catalogo!");
          return
        }

          this.changeBusiness({ business: this.filters.business, location: null });
          this.$toast.success("agregado con exito!");
          this.step = 1;
          this.close();
        //this.catalogues.push(this.editedItem);
      }
    },
    set_is_new(item){
      const index = this.itemSelected.indexOf(item);
      this.$set(this.itemSelected[index], 'isNew', true);
    },

    async downloadXLSX() {
      if (this.itemSelected.length === 0) {
        this.$toast.info("No hay artículos para exportar.");
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Catálogo");

      // Columnas dinámicas según las monedas del primer ítem
      const currencyColumns = [];
      const firstCurrencies = this.itemSelected[0].item_currencies || [];
      for (const curr of firstCurrencies) {
        const code = curr.currency_code || curr.currency_name || curr.currency_id;
        currencyColumns.push({ header: `Precio Venta (${code})`, key: `sale_${curr.currency_id}`, width: 22 });
        currencyColumns.push({ header: `Precio Costo (${code})`, key: `cost_${curr.currency_id}`, width: 22 });
      }

      worksheet.columns = [
        { header: "ID",              key: "item_id",               width: 8  },
        { header: "Descripción",     key: "item_name",             width: 35 },
        { header: "Tipo",            key: "item_type_name",        width: 15 },
        { header: "Unidad",          key: "unit_name",             width: 12 },
        { header: "Categoría",       key: "category_name",         width: 20 },
        { header: "Cuenta Contable", key: "account_categorie_name",width: 25 },
        { header: "ITBIS",           key: "tax_type_name",         width: 22 },
        { header: "Código Barra",    key: "code",                  width: 15 },
        { header: "Inventariable",   key: "is_inventoriable",      width: 14 },
        { header: "Venta Negativa",  key: "negative_sale",         width: 14 },
        { header: "Activo",          key: "active",                width: 10 },
        { header: "R. Mínimo",       key: "min",                   width: 10 },
        { header: "R. Máximo",       key: "max",                   width: 10 },
        ...currencyColumns,
      ];

      // Estilo encabezado
      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
      headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1976D2" } };

      for (const item of this.itemSelected) {
        const row = {
          item_id:               item.item_id,
          item_name:             item.item_name,
          item_type_name:        item.item_type_name,
          unit_name:             item.unit_name,
          category_name:         item.category_name,
          account_categorie_name:item.account_categorie_name,
          tax_type_name:         item.tax_type_name,
          code:                  item.code,
          is_inventoriable:      item.is_inventoriable ? "Sí" : "No",
          negative_sale:         item.negative_sale    ? "Sí" : "No",
          active:                item.active           ? "Activo" : "Inactivo",
          min:                   item.min,
          max:                   item.max,
        };

        for (const curr of (item.item_currencies || [])) {
          row[`sale_${curr.currency_id}`] = curr.sale_price;
          row[`cost_${curr.currency_id}`] = curr.cost_price;
        }

        worksheet.addRow(row);
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Catalogo_${(this.editedItem.name || "items").replace(/\s+/g, "_")}.xlsx`;
      link.click();
    },
  },
};
</script>
